import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class Size
  * Provides an interface for adjusting a stage's size.
  */
export default class Size extends Component {
  /** @constructor
    * Creates a new instance of Size
    * @prop {url} dataURL - the firebase reference url for the stage
    * @prop {integer} width - the width of the stage in pixels
    * @prop {integer} height - the height of the stage in pixels
    */
  constructor(props) {
    super(props);
    this.firebaseRef = firebase.database().ref(this.props.dataURL);
    this.state = {
      width: this.props.width || 1024,
      height: this.props.height || 768
    }
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function componentWillRecieveNewProps
    * Updates the component state with updated props.
    */
  componentWillRecieveNewProps(newProps) {
    this.setState({
      width: newProps.width,
      height: newProps.height
    });
  }
  /** @function handleNumberChange
    * Updates the component state to reflect changes
    * in numeric input fields.
    * @param {InputEvent} event - the change event
    */
  handleNumberChange(event) {
    const target = event.target;
    const value = parseInt(target.value, 10);
    const name = target.name;
    this.setState({[name]: value});
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur(event) {
    firebase.database()
    .ref(`${this.props.dataURL}/${event.target.name}`)
    .set(this.state[event.target.name]);
  }
  /** @function render
    * Renders the size component
    */
  render() {
    return (
      <div className="input-group">
        <label>Size</label>
        <div className="dimension-inputs">
          <input type="number" name="width"
            value={this.state.width}
            onChange={this.handleNumberChange}
            onBlur={this.handleBlur}
            />
          x
          <input type="number" name="height"
            value={this.state.height}
            onChange={this.handleNumberChange}
            onBlur={this.handleBlur}
            />
          pixels
        </div>
      </div>
    );
  }
}

Size.propTypes = {
  dataURL: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/stage-editor/size.js